/** @jsxImportSource @emotion/react */
import React, { useState, useEffect } from "react";
import { css } from "@emotion/react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import PlaceIcon from "@mui/icons-material/Place";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Popover from "@mui/material/Popover";
import SearchIcon from "@mui/icons-material/Search";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { os } from "../../utils/util";
import {
  Map as BMap,
  CustomOverlay,
  ZoomControl,
  MapApiLoaderHOC,
} from "react-bmapgl";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Tooltip from "@mui/material/Tooltip";
import CallIcon from "@mui/icons-material/Call";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getDealersDetails, getPreDealersDetails } from "./requestCall";
import positionIcon from "../../assets/icons/position.svg";
import { v4 } from "uuid";

const dealerSearchWrapper = (matches) => css`
  background: white;
  display: flex;
  flex-direction: ${matches ? "column" : "row"};
`;
const dealerListWrapper = (matches) => css`
  padding: 0 ${matches ? "0" : "15px"};
  background: #1f1f1f;
  width: ${matches ? "100%" : "400px"};
  order: ${matches ? 2 : 0};
  height: 600px;
  max-height: ${matches ? "277px" : "none"};
  .MuiTypography-caption {
    padding: 0 16px;
    color: #808080;
    display: block;
    text-align: ${matches ? "center" : "unset"};
    margin-top: ${matches ? "20px" : "0"};
  }
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-track {
    background: #1f1f1f;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgb(136, 136, 136);
    border-radius: 10px;
  }
`;
const mapWrapper = (matches) => css`
  width: ${matches ? "100%" : "calc(100% - 400px)"};
  height: ${matches ? "400px" : "600px"};

  .MuiTooltip-tooltip {
    max-width: 360px;
    background-color: #1f1f1f;
    padding: 4px 30px;
    .MuiTypography-h6 {
      margin: 0 0 30px 0;
    }
    .MuiTypography-body1 {
      color: #7b7b7b;
    }
    .MuiBox-root {
      margin: 20px 0;
      display: flex;
      flex-direction: column;
    }
  }
`;
const customIcon = css`
  width: 25px;
  height: 25px;
  cursor: pointer;
`;
const infoWrapper = css`
  width: 260px;
  .MuiTypography-h6 {
    font-size: 14px;
  }
`;
const infoDetailWrapper = css`
  display: flex;
`;
const address = css`
  display: flex;
  .MuiTypography-body1 {
    font-size: 12px;
  }
`;
const infoDetail = css`
  display: flex;
  margin-bottom: 0;
  .MuiTypography-body1 {
    margin: 0 10px;
    font-size: 12px;
  }
  .MuiSvgIcon-root {
    font-size: 12px;
    height: 16px;
  }
`;
const tooltipWrapper = css``;
const arrow = css`
  width: 0;
  height: 0;
  border-top: 15px solid #1f1f1f;
  border-right: 15px solid transparent;
  border-left: 15px solid transparent;
  position: absolute;
  bottom: 0;
  left: 146px;
`;
const mobileInfoWrapper = css`
  padding-left: 10px;
  padding-right: 10px;
  height: calc(100vh - 267px);
  background: black;
`;
const cityChangeRight = css`
  cursor: pointer;
`;
const mobileAddress = css`
  margin: 20px 0;
  display: flex;
  .MuiTypography-root {
    color: #7b7b7b;
  }
  .MuiSvgIcon-root {
    color: #7b7b7b;
  }
`;
const mobileTelDetail = css`
  margin: 10px 0;
  display: flex;
  .MuiSvgIcon-root {
    color: #7b7b7b;
  }
  .MuiTypography-body1 {
    margin-left: 10px;
    color: #479fd9;
  }
`;
const mobileInfo = css`
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 20px;
  .MuiTypography-h6 {
    margin: 10px 0 30px 0;
    color: white;
  }
`;
const listPanelWrapper = css`
  .MuiDivider-root {
    border-color: #333;
    margin: 0 15px;
  }
  .MuiListItem-root {
    .MuiBox-root {
      display: flex;
      margin-bottom: 10px;
      justify-content: space-between;
      .MuiTypography-root {
        font-size: 14px;
      }
      .MuiTypography-root:nth-of-type(2) {
        font-size: 12px;
      }
    }
    .MuiTypography-body2 {
      .MuiTypography-root {
        font-size: 12px;
        color: #808080;
      }
    }
  }
`;
const distance = css`
  font-size: 12px;
  color: #808080;
`;
const dealerListInfo = css`
  font-size: 12px;
  color: #808080;
  width: 240px;
`;
const cityBarWrapper = (matches) => css`
  padding: 0 ${matches ? "15px" : "11px"};
  display: flex;
  justify-content: space-between;
  height: 50px;
  .MuiBox-root {
    display: flex;
    line-height: 50px;
    color: #7b7b7b;
    .MuiSvgIcon-root {
      line-height: 50px;
      height: 50px;
      font-size: 20px;
    }
    .MuiSvgIcon-root:nth-of-type(2) {
      font-size: 16px;
    }

    .MuiTypography-body1 {
      line-height: 50px;
      margin: 0 10px;
      font-size: 14px;
    }
  }
`;
const placeIcon = css`
  color: #4cabea;
`;
const myLocationIcon = css`
  color: white;
  cursor: pointer;
`;
const dealerItemTitleWrapper = css`
  text-align: center;
  font-size: 36px;
  margin: 36px 0;
  cursor: unset;
`;
const dealerDetailHeader = css`
  display: flex;
  color: white;
  background-color: #1f1f1f;
  svg,
  p {
    height: 50px;
    line-height: 50px;
  }
`;
const searchBarWrapper = () => css`
  .MuiPaper-root {
    background: #1f1f1f;
    box-shadow: none;
    svg {
      font-size: 20px;
    }
    .MuiButtonBase-root {
      color: white;
    }
    .MuiInputBase-root {
      color: white;
      font-size: 14px;
    }
  }
`;
const changeCityWrapper = () => css`
  .MuiPopover-paper {
    background: #333;
    min-width: 300px;
  }
`;
const dealerSearchBannerImg = css`
  width: 100%;
  display: block;
`;
const popoverChoseHeader = () => css`
  button {
    color: white;
  }
`;
const dealerCounts = (matches) => css`
  .MuiTypography-root {
    border-top: ${matches ? "none" : "1px solid"};
    padding-top: ${matches ? "0" : "12px"};
    margin-left: 16px;
    padding-left: 0;
    padding-right: 0;
  }
`;
const cityWrapper = (isSelectedCity) => css`
  color: ${isSelectedCity ? "#1976d2" : "white"};
`;
const provinceWrapper = (isSelectedProvince) => css`
  color: ${isSelectedProvince ? "#1976d2" : "white"};
`;
const provinceAndCity = css`
  display: flex;
  flex-wrap: wrap;
  .MuiTypography-root {
    width: 25%;
    text-align: center;
  }
`;
const mobileTopBarWrapper = () => css`
  .MuiBox-root {
    background: #333;
    .MuiPaper-root {
      background: #333;
    }
  }
`;
const functionality = css`
  margin-right: 5px;
  .MuiTypography-root {
    display: inline;
    padding: 3px 5px;
    border: 1px solid #808080;
    border-radius: 4px;
    font-size: 10px;
    color: #cccccc;
  }
`;
const currentDisplayLocation = css`
  max-width: 180px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const categoryWrapper = css`
  display: flex;
  justify-content: flex-start;
`;
const aaa = css`
  .MuiTypography-root,
  .MuiInputBase-root {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif !important;
  }
`;
const popFunctionality = css`
  margin-top: 10px;
  margin-right: 5px;
  .MuiTypography-root {
    display: inline;
    padding: 3px 5px;
    border: 1px solid #808080;
    border-radius: 4px;
    font-size: 10px;
    color: #cccccc;
  }
`;
const bannerWrapper = (theme) => css`
  position: relative;
  .MuiTypography-body1 {
    position: absolute;
    top: 40px;
    left: 80px;
    font-size: 48px;
    font-family: ${theme.typography.h2.fontFamily} !important;
  }
`;
const showNoDealersFound = css`
  text-align: center;
  margin-top: 120px;
  .MuiTypography-root {
    font-size: 16px;
    color: #808080;
  }
`;
const sortByOrder = (data) => {
  return data?.sort((a, b) => a.attributes.distance - b.attributes.distance);
};
const getMobileDetailPage = (
  currentDisplayedDealer,
  dealerList,
  setCurrentDisplayedDealer,
  isAllowPosition,
  bannerImage
) => {
  const dealer = dealerList.find(
    (item) => item.attributes.title === currentDisplayedDealer
  );
  return (
    <Box css={mobileInfoWrapper}>
      <Box
        css={dealerDetailHeader}
        onClick={() => setCurrentDisplayedDealer("")}
      >
        <ChevronLeftIcon />
        <Typography>返回</Typography>
      </Box>
      {bannerImage && (
        <img
          css={dealerSearchBannerImg}
          src={`${process.env.REACT_APP_BASEURL}${bannerImage}`}
          alt="dealer search banner"
        />
      )}
      <Box css={mobileInfo}>
        <Typography variant="h6">{dealer?.attributes?.title}</Typography>
        <Typography component="div" css={mobileAddress}>
          <Typography>{`${
            dealer?.attributes.distance && isAllowPosition
              ? `距你${dealer?.attributes.distance}km`
              : ""
          }${isAllowPosition ? " | " : ""}${
            dealer?.attributes?.address
          }`}</Typography>
        </Typography>
        <Typography component="div" css={mobileTelDetail}>
          <CallIcon />
          <Typography>{dealer?.attributes?.contactNumber}</Typography>
        </Typography>
        <div css={categoryWrapper}>
          {dealer?.attributes?.dealer_categories?.data?.map((category) => (
            <div css={functionality} key={v4()}>
              <Typography>{category?.attributes?.name}</Typography>
            </div>
          ))}
        </div>
      </Box>
    </Box>
  );
};
const getDealerDistance = (lat1, lng1, lat2, lng2) => {
  var rad1 = ((lat1 || 0) * Math.PI) / 180.0;
  var rad2 = ((lat2 || 0) * Math.PI) / 180.0;
  var a = rad1 - rad2;
  var b = ((lng1 || 0) * Math.PI) / 180.0 - ((lng2 || 0) * Math.PI) / 180.0;
  var r = 6378137;
  var distance =
    r *
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
          Math.cos(rad1) * Math.cos(rad2) * Math.pow(Math.sin(b / 2), 2)
      )
    );
  return (distance / 1000).toFixed(1);
};
const SearchBar = ({ searchWords, onFiltered, matches }) => {
  const [words, setWords] = useState(searchWords);
  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      onFiltered(e.target.value);
    }
  };
  const handleChange = (e) => {
    setWords(e.target.value);
  };
  useEffect(() => {
    setWords(searchWords);
  }, [searchWords]);
  return (
    <Box css={() => searchBarWrapper(matches)}>
      <Paper sx={{ p: "2px 4px", display: "flex", alignItems: "center" }}>
        <IconButton sx={{ p: "10px" }} aria-label="menu">
          <SearchIcon />
        </IconButton>
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="查找经销商"
          onKeyDown={handleKeyDown}
          value={words}
          onChange={handleChange}
        />
        {words.length !== 0 && (
          <IconButton
            sx={{ p: "10px" }}
            aria-label="close"
            onClick={() => {
              onFiltered("");
              setWords("");
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </Paper>
    </Box>
  );
};
const getCityCenter = (dealerList) => {
  const lastIndex = dealerList.length - 1;
  const sortByLat = dealerList.sort(
    (a, b) => a.attributes.latitude - b.attributes.latitude
  );
  const sortByLng = dealerList.sort(
    (a, b) => a.attributes.longitude - b.attributes.longitude
  );
  return {
    lat:
      (sortByLat[0].attributes.latitude +
        sortByLat[lastIndex].attributes.latitude) /
      2,
    lng:
      (sortByLng[0].attributes.longitude +
        sortByLng[lastIndex].attributes.longitude) /
      2,
  };
};
const CityBar = ({
  matches,
  fullDealerList,
  getLocation,
  displayedLocation,
  setDisplayedLocation,
  setDealerList,
  setCurrentCity,
  setCenter,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = React.useState(1);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const fullProvincesArr = [
    ...new Set(
      fullDealerList?.map((dealer) => {
        return dealer.attributes.city.data.attributes.province.data
          ? dealer.attributes.city.data.attributes.province.data.attributes
              .title
          : dealer.attributes.city.data.attributes.name;
      })
    ),
  ];
  const fullProvinces = fullProvincesArr?.map((province) => {
    return {
      province: province,
      isMunicipality: !fullDealerList.some(
        (i) =>
          i.attributes.city.data.attributes.province.data?.attributes?.title ===
          province
      ),
    };
  });
  const getCityByProvince = (province) => {
    return [
      ...new Set(
        fullDealerList
          .filter((dealer) => {
            return (
              dealer.attributes.city.data.attributes.province.data?.attributes
                ?.title === province
            );
          })
          .map((dealer) => dealer.attributes.city.data.attributes.name)
      ),
    ];
  };
  const cityMap = new Map(null);
  fullProvinces.forEach((province) =>
    cityMap.set(province.province, getCityByProvince(province.province))
  );
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 1) {
      setSelectedCity("");
    }
  };

  const handleProvinceClick = (province) => {
    if (province.isMunicipality) {
      const dealersInChosenPro = fullDealerList.filter(
        (dealer) =>
          dealer.attributes.city.data.attributes.name === province.province
      );

      setCurrentCity(province.province);
      setDisplayedLocation(province.province);
      setDealerList(dealersInChosenPro);
      setCenter(getCityCenter(dealersInChosenPro));
      setAnchorEl(false);
    } else {
      setSelectedProvince(province.province);
      setValue(2);
    }
  };
  const handleCityClick = (city) => {
    setSelectedCity(city);
    setCurrentCity(city);
    setDisplayedLocation(`${selectedProvince}${city}`);
    const dealersInChosenCity = fullDealerList.filter(
      (dealer) => dealer.attributes.city.data.attributes.name === city
    );
    setCenter(getCityCenter(dealersInChosenCity));
    setDealerList(dealersInChosenCity);
    setAnchorEl(false);
  };
  return (
    <Box css={() => cityBarWrapper(matches)}>
      <Box>
        <PlaceIcon css={placeIcon} />
        <Typography css={currentDisplayLocation}>
          {displayedLocation}
        </Typography>
        <MyLocationIcon
          css={myLocationIcon}
          onClick={() => getLocation(fullDealerList)}
        />
      </Box>
      <Box css={cityChangeRight}>
        <Box onClick={handleClick}>
          <Typography>更改城市</Typography>
          <KeyboardArrowDownIcon />
        </Box>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          disablePortal
          css={changeCityWrapper}
        >
          <Box sx={{ width: "100%" }} css={popoverChoseHeader}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="wrapped label tabs example"
            >
              <Tab value={1} label={selectedProvince || "请选择省"}></Tab>
              {value === 2 && (
                <Tab value={2} label={selectedCity || "请选择市"}></Tab>
              )}
            </Tabs>
          </Box>
          <Box css={provinceAndCity}>
            {value === 1 &&
              fullProvinces?.map((province) => (
                <Typography
                  css={() =>
                    provinceWrapper(province.province === selectedProvince)
                  }
                  key={province.province}
                  onClick={() => handleProvinceClick(province)}
                >
                  {province.province}
                </Typography>
              ))}

            {value === 2 &&
              cityMap.get(selectedProvince).map((city) => (
                <Typography
                  css={() => cityWrapper(city === selectedCity)}
                  key={city}
                  onClick={() => handleCityClick(city)}
                >
                  {city}
                </Typography>
              ))}
          </Box>
        </Popover>
      </Box>
    </Box>
  );
};
const renderNoDealerFiltered = () => {
  return (
    <Box css={showNoDealersFound}>
      <Typography>未搜索到经销商</Typography>
    </Box>
  );
};

const DealerSearch = () => {
  const [dealerList, setDealerList] = useState([]);
  const [showDealerBanner, setShowDealerBanner] = useState(false);
  const [bannerImage, setBannerImage] = useState("");
  const [showDealerSearchContent, setShowDealerSearchContent] = useState(false);
  const [fullDealerList, setFullDealerList] = useState([]);
  const [center, setCenter] = useState({});
  const [currentDisplayedDealer, setCurrentDisplayedDealer] = useState("");
  const [isAllowPosition, setIsAllowPosition] = useState(false);
  const [searchWords, setSearchWords] = useState("");
  const [currentCity, setCurrentCity] = useState("");
  const [displayedLocation, setDisplayedLocation] = useState("");
  const [dealerItemTitle, setDealerItemTitle] = useState("");
  const [bannerTitle, setBannerTitle] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const matches = useMediaQuery("(max-width: 415px)");

  useEffect(() => {
    if (!matches) {
      document.getElementById("stickyLinks").style.display = "none";
    }
    getPreDealersDetails().then((res) => {
      document.title = res?.data?.data?.attributes?.title;
      const bannerImageItem = res?.data?.data?.attributes?.body.find(
        (item) => item.__component === "components.banner-image-with-text-tiles"
      );
      const dealerItem = res?.data?.data?.attributes?.body.find(
        (item) => item.__component === "components.dealer-search-on-baidu"
      );
      if (bannerImageItem) {
        setShowDealerBanner(true);
        setBannerTitle(bannerImageItem.title);
        setBannerImage(bannerImageItem?.bannerImage?.data?.attributes?.url);
      }
      if (dealerItem) {
        setDealerItemTitle(dealerItem.title);
        setShowDealerSearchContent(true);
        getDealers([], 1);
      }
    });
  }, []);
  const getDealers = (currentDealers, nextPage) => {
    getDealersDetails(nextPage).then((response) => {
      if (
        response.data.meta.pagination.total >
        response.data.meta.pagination.page * 100
      ) {
        getDealers(
          [...currentDealers, ...response.data.data],
          response.data.meta.pagination.page + 1
        );
      } else {
        setFullDealerList([...currentDealers, ...response.data.data]);
        getLocation([...currentDealers, ...response.data.data]);
      }
    });
  };
  const getLocation = (dealers) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          setCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });

          var myGeo = new window.BMapGL.Geocoder();
          myGeo.getLocation(
            new window.BMapGL.Point(
              position.coords.longitude,
              position.coords.latitude
            ),
            function (result) {
              if (result) {
                setDisplayedLocation(result.address);
              }
            }
          );
          var myCity = new window.BMapGL.LocalCity();
          myCity.get((res) => {
            dealers?.forEach((dealer) => {
              dealer.attributes.distance = getDealerDistance(
                position.coords.latitude,
                position.coords.longitude,
                dealer.attributes.latitude,
                dealer.attributes.longitude
              );
            });
            setCurrentCity(res.name);
            setIsLoading(false);
            setDealerList(
              sortByOrder(
                dealers.filter(
                  (dealer) =>
                    dealer.attributes.city.data.attributes.name === res.name
                )
              )
            );
          });
          setIsAllowPosition(true);
        },
        function () {
          setCenter({ lat: 39.91, lng: 116.4 });
          setDisplayedLocation("北京市");
          setCurrentCity("北京市");
          dealers?.forEach((dealer) => {
            dealer.attributes.distance = getDealerDistance(
              39.91,
              116.4,
              dealer.attributes.latitude,
              dealer.attributes.longitude
            );
          });
          setIsLoading(false);
          setDealerList(
            sortByOrder(
              dealers.filter(
                (dealer) =>
                  dealer.attributes.city.data.attributes.name === "北京市"
              )
            )
          );
        },
        { timeout: 5000 }
      );
    } else {
      // your browser/device doesn't support geolocation
    }
  };
  const handleClick = (e, t) => {
    e.stopPropagation();
    setCenter({ lng: t.longitude, lat: t.latitude + 0.05 });
    setCurrentDisplayedDealer("");
    setTimeout(() => setCurrentDisplayedDealer(t.title), 200);
  };
  const handleOpen = () => {
    setCurrentDisplayedDealer("");
  };
  const onFiltered = (keyWords) => {
    setSearchWords(keyWords);
    const dealersOfCurrentCity = fullDealerList.filter(
      (dealer) => dealer.attributes.city.data.attributes.name === currentCity
    );
    keyWords && keyWords.trim()
      ? setDealerList(
          dealersOfCurrentCity.filter(
            (item) =>
              item.attributes.title?.indexOf(keyWords) > -1 ||
              item.attributes.address?.indexOf(keyWords) > -1
          )
        )
      : setDealerList(dealersOfCurrentCity);
  };
  return showDealerSearchContent ? (
    matches && currentDisplayedDealer ? (
      getMobileDetailPage(
        currentDisplayedDealer,
        dealerList,
        setCurrentDisplayedDealer,
        isAllowPosition,
        bannerImage
      )
    ) : (
      <Box css={aaa}>
        {showDealerBanner && !matches && os().isPc && (
          <Box css={bannerWrapper}>
            {bannerImage && (
              <img
                css={dealerSearchBannerImg}
                src={`${process.env.REACT_APP_BASEURL}${bannerImage}`}
                alt="dealer search banner"
              />
            )}
            <Typography>{bannerTitle}</Typography>
          </Box>
        )}
        <Box css={() => dealerSearchWrapper(matches)}>
          {matches && (
            <div css={mobileTopBarWrapper}>
              <CityBar
                matches={matches}
                dealerList={dealerList}
                fullDealerList={fullDealerList}
                getLocation={getLocation}
                displayedLocation={displayedLocation}
                setDisplayedLocation={setDisplayedLocation}
                setDealerList={setDealerList}
                setCurrentCity={setCurrentCity}
                setCenter={setCenter}
              />
              <SearchBar
                searchWords={searchWords}
                onFiltered={onFiltered}
                matches={matches}
              />
            </div>
          )}
          <Box css={() => dealerListWrapper(matches)}>
            {!matches && (
              <Typography css={dealerItemTitleWrapper}>
                {dealerItemTitle}
              </Typography>
            )}
            {!matches && (
              <CityBar
                matches={matches}
                dealerList={dealerList}
                fullDealerList={fullDealerList}
                getLocation={getLocation}
                displayedLocation={displayedLocation}
                setDisplayedLocation={setDisplayedLocation}
                setDealerList={setDealerList}
                setCurrentCity={setCurrentCity}
                setCenter={setCenter}
              />
            )}
            {!matches && (
              <SearchBar
                searchWords={searchWords}
                onFiltered={onFiltered}
                matches={matches}
              />
            )}
            <Box css={() => dealerCounts(matches)}>
              <Typography variant="caption">
                为您找到 {dealerList ? dealerList.length : 0} 个经销商
              </Typography>
            </Box>
            {!isLoading &&
              (dealerList.length === 0
                ? renderNoDealerFiltered()
                : dealerList.map((dealer) => {
                    return (
                      <Box css={listPanelWrapper} key={v4()}>
                        <List
                          onClick={(e) => handleClick(e, dealer.attributes)}
                          sx={{ width: "100%" }}
                        >
                          <ListItem alignItems="flex-start">
                            <ListItemText>
                              <Box>
                                <Typography>
                                  {dealer.attributes.title}
                                </Typography>
                                {dealer?.attributes.distance &&
                                  isAllowPosition && (
                                    <Typography css={distance}>
                                      {dealer?.attributes.distance}km
                                    </Typography>
                                  )}
                              </Box>
                              <Typography css={dealerListInfo}>
                                {dealer?.attributes?.address}
                                <br></br>
                                {dealer?.attributes.contactNumber}
                              </Typography>
                              <div css={categoryWrapper}>
                                {dealer?.attributes?.dealer_categories?.data?.map(
                                  (category) => (
                                    <div css={functionality} key={v4()}>
                                      <Typography>
                                        {category?.attributes?.name}
                                      </Typography>
                                    </div>
                                  )
                                )}
                              </div>
                            </ListItemText>
                          </ListItem>
                          <Divider variant="inset" component="li" />
                        </List>
                      </Box>
                    );
                  }))}
          </Box>
          <Box css={() => mapWrapper(matches)}>
            <BMap
              zoom="12"
              style={{ height: matches ? "400px" : "600px" }}
              onClick={handleOpen}
              center={center}
            >
              <ZoomControl anchor={1} />
              {dealerList?.map((dealer) => {
                return (
                  <div key={v4()}>
                    <CustomOverlay
                      position={{
                        lng: dealer.attributes.longitude,
                        lat: dealer.attributes.latitude,
                      }}
                    >
                      <Tooltip
                        PopperProps={{
                          disablePortal: true,
                        }}
                        open={
                          currentDisplayedDealer ===
                            dealer?.attributes?.title && !matches
                        }
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        placement="top"
                        css={tooltipWrapper}
                        title={
                          <Box css={infoWrapper}>
                            <Typography variant="h6">
                              {dealer?.attributes?.title}
                            </Typography>
                            <Typography component="div" css={address}>
                              <Typography>{`${
                                dealer?.attributes.distance && isAllowPosition
                                  ? `距你${dealer?.attributes.distance}km`
                                  : ""
                              }${isAllowPosition ? " | " : ""}${
                                dealer?.attributes?.address || ""
                              }`}</Typography>
                            </Typography>
                            <Box css={infoDetailWrapper}>
                              <Typography component="div" css={infoDetail}>
                                <CallIcon />
                                <Typography>
                                  {dealer?.attributes?.contactNumber}
                                </Typography>
                              </Typography>

                              <div css={categoryWrapper}>
                                {dealer?.attributes?.dealer_categories?.data?.map(
                                  (category) => (
                                    <div css={popFunctionality} key={v4()}>
                                      <Typography>
                                        {category?.attributes?.name}
                                      </Typography>
                                    </div>
                                  )
                                )}
                              </div>
                            </Box>
                            <div css={arrow}></div>
                          </Box>
                        }
                      >
                        <img
                          onClick={(e) => handleClick(e, dealer.attributes)}
                          css={customIcon}
                          src={positionIcon}
                          alt="position icon"
                        />
                      </Tooltip>
                    </CustomOverlay>
                  </div>
                );
              })}
            </BMap>
          </Box>
        </Box>
      </Box>
    )
  ) : (
    ""
  );
};
//export default MapApiLoaderHOC({ ak: "" })(
//  DealerSearch
//);
const mapApiConfig = {
  ak: "dHm5oGIMGmokGVNlM8Ucf76LGxcdzNDf",
  // 根据需要添加其他配置参数
};
export default MapApiLoaderHOC(mapApiConfig)(DealerSearch);
